const GENERIC_ALERT_PREFIX = "alert";

export const GENERIC_ALERT_TEST_IDS = {
    HEADER: `${GENERIC_ALERT_PREFIX}_header`,
    HEADER_ICON: `${GENERIC_ALERT_PREFIX}_header_icon`,
    HEADER_TITLE: `${GENERIC_ALERT_PREFIX}_header_title`,
    HEADER_MESSAGE: `${GENERIC_ALERT_PREFIX}_header_msg`,
    CONTENT: `${GENERIC_ALERT_PREFIX}_content`,
    ALERT_INFO: `${GENERIC_ALERT_PREFIX}_info`,
    ALERT_SUB_INFO: `${GENERIC_ALERT_PREFIX}_subinfo`,
    PRIMARY_ACTION_BUTTON: `${GENERIC_ALERT_PREFIX}_primary_btn`,
    SECONDARY_ACTION_BUTTON: `${GENERIC_ALERT_PREFIX}_sec_btn`,
    CLOSE_ICON: `${GENERIC_ALERT_PREFIX}_close_icon`,
};
